import React from "react";
// eslint-disable-next-line no-unused-vars
import { Typography, Button, makeStyles } from "@material-ui/core";
// import OnboardingPDF from "../images/Onboarding Email_ Society ANPR.pdf";

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(4),
		textAlign: "left",
	},
	iframeContainer: {
		display: "grid",
		gridTemplateColumns: "1fr 1fr",
		gap: theme.spacing(4),
		[theme.breakpoints.down("sm")]: {
			gridTemplateColumns: "1fr", // Change to one column on mobile screens
		},
	},
	iframe: {
		border: "none",
		width: "450px",
		height: "250px",
		borderRadius: "5px",
	},
	iframePdf: {
		border: "none",
		width: "280px",
		height: "360px",
		borderRadius: "8px",
		boxShadow: theme.shadows[3],
	},
	pdfContainer: {
		position: "relative",
		display: "flex",
		flexDirection: "column",
	},
	downloadButton: {
		backgroundColor: "#ddd",
		color: "#334D6E",
		alignSelf: "flex-end",
		padding: "4px 12px",
		"&:hover": {
			backgroundColor: "#ccc",
		}
	},
	videoContainer: {
		marginBottom: theme.spacing(1), // Add margin at the bottom of each video container
	},
}));

const ResourcesComponent = () => {
	const classes = useStyles();

	return (
		<div style={{ paddingTop: 24, paddingBottom: 24 }}>
			<div className="secondaryColor fontWeightSemiBold" style={{ fontSize: 14, marginBottom: 12 }}>Tutorial Videos</div>
			<div className='rowFilterScroll' style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
				<div style={{ display: "flex", gap: 25 }}>
					<iframe
						title="Onboarding Video"
						className={classes.iframe}
						src="https://www.youtube.com/embed/krzhGy-mNQ8"
						allowFullScreen>
					</iframe>


					<iframe
						title="System Flow Video"
						className={classes.iframe}
						src="https://www.youtube.com/embed/loJgTJEKv2U"
						allowFullScreen></iframe>
				</div>
			</div>

			<div className="secondaryColor fontWeightSemiBold" style={{ fontSize: 14, marginBottom: 12, marginTop: 50 }}>Documents</div>
			<div className='rowFilterScroll' style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
				<div style={{ display: "flex", gap: 25 }}>
					<iframe
						title="onbarding-pdf"
						className={classes.iframePdf}
						src="https://drive.google.com/file/d/1j8ECFnu_gaxfgaoof7zp_IwFdTElVgPK/preview"
						width="640"
						height="480"
						allow="autoplay">

					</iframe>
				</div>
			</div>
		</div>
	);
};

export default ResourcesComponent;
